import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { BoxDetails } from '../components/BoxDetails'
import { useBoxById } from '../hooks/useBoxes'
import { BoxesLayout as BoxLayout } from '../layout/BoxesLayout'
import { Loader } from '../ui/Loader'
import { useParams } from 'react-router'

export const SingleBoxPage: FC = () => {
  const { address } = useParams()

  if (!address) {
    throw new Error('Box address is required')
  }

  const { data: box, isFetching, refetch, isError } = useBoxById(address)

  if (isFetching && !box) {
    return <Loader />
  }

  if (!box || isError) {
    return (
      <FormattedMessage id="box-not-found" defaultMessage="Опрос не найден" />
    )
  }

  return (
    <BoxLayout
      loading={isFetching && !box}
      error={isError}
      onRetryFetch={refetch}
      titleElement={null}
      tabsElement={null}
    >
      <BoxDetails box={box} />
    </BoxLayout>
  )
}

export const singleBoxPagePath = '/box/:address'
export const singleBoxPageBoxPath = '/box/'
